import {isArray} from 'lodash';

type Font = string[] | mapboxgl.StyleFunction | undefined;

export default function transformMapboxStyleFonts(
    style: mapboxgl.Style,
    transformer: (font: string[]) => string[]
): mapboxgl.Style {

    if (!style.layers) return style;

    return {
        ...style,
        layers: style.layers.map(layer => {
            if (layer.type !== 'symbol' || !layer.layout) return layer;
            const prevFont = (layer.layout as any)['text-font'] as Font;

            if (!prevFont) return layer;

            let nextFont;
            if (isArray(prevFont)) {
                nextFont = transformer(prevFont);
            } else if (prevFont.stops) {
                nextFont = {
                    ...prevFont,
                    stops: prevFont.stops.map(([key, value]) => [key, transformer(value)]),
                };
            }

            return {
                ...layer,
                layout: {...layer.layout, 'text-font': nextFont}
            };
        })
    };
}
